// TODO make this more generic (may be once we have some prefix for dashboard URLs)
// Adding URLs one by one will get very unmanageable

export const UNAUTHORIZED_ONLY_ENDPOINTS = [
  '/',
  '/login*',
  '/login/**',
  '/register*',
  '/register/**',
  '/book-trial-class*',
  '/lp/learn-coding*',
]

export const AUTHORIZED_ONLY_ENDPOINTS = [
  '/batches/**',
  '/dashboard/**',
  '/student/**',
  '/teacher/**',
  '/trial-class/**',
  '/feedback/**',
  '/onboarding/**',
  '/apps/scratch/**',
  '/competitions/**/submit*',
  '/competitions/**/**/complete/**',
  '/competitions/**/view-submission*',
  '/competitions/**/problems*',
  '/summer-camp/checkout/**',
  '/phonepe-promo/checkout/**',
  '/competition/**/problems/**',
  '/lp/learn-coding/thank-you*',
  '/competitions/**/invite/**',
]

export const RESTRICTED_PATHS = [
  '/batches/**',
  '/lp/**',
  '/trial-class/**',
  '/competitions/**/problems/**',
  '/competitions/**/problems',
  '/competitions/**/competition-leaderboard',
  '/competitions/**/submissions',
  '/book-trial-class',
  '/payment/**',
  '/rewind/**',
  '/payment-status*',
  '/register*',
  '/login*',
  '/login/**',
  '/register/**',
  '/404',
]

// Microsoft Clarity should run on these critical product pages
export const CLARITY_INCLUDE_GLOBS = [
  '/',
  '/trial-class/**',
  '/login*',
  '/login/**',
  '/register*',
  '/register/**',
  '/teacher/application*',
  '/teacher/application/**',
]

// Student trial funnel pages where a logged-in student is identified in
// Mixpanel. Mixpanel is only used for this funnel (signup to trial joined).
export const MIXPANEL_FUNNEL_GLOBS = [
  '/trial-class/spoken-languages*',
  '/trial-class/spoken-languages/**',
  '/trial-class/system-confirmation*',
  '/trial-class/system-confirmation/**',
  '/trial-class/purchase-intent*',
  '/trial-class/purchase-intent/**',
  '/trial-class/grade-readiness*',
  '/trial-class/grade-readiness/**',
  '/trial-class/grade-not-ready*',
  '/trial-class/grade-not-ready/**',
  '/trial-class/booking*',
  '/trial-class/booking/**',
  '/trial-class/track-booking*',
  '/trial-class/track-booking/**',
  '/trial-class/join*',
  '/trial-class/join/**',
]

// Optimonk should run on these routes even if they are otherwise restricted
export const OPTIMONK_FORCE_INCLUDE_GLOBS = [
  '/trial-class/spoken-languages*',
  '/trial-class/spoken-languages/**',
]

// Facebook pixel should use the teacher dataset ID on these routes regardless of login state
export const FB_TEACHER_PIXEL_FORCE_INCLUDE_GLOBS = [
  '/teach',
  '/teach/**',
  '/register/teacher*',
  '/register/teacher/**',
]

export const GENERAL_HELLO_BAR_EXCLUSION_GLOBS = [
  '/trial-class/**',
  '/dashboard/**',
  '/dashboard*',
  '/teacher/application*',
  '/teacher/application/**',
  '/teacher/overview*',
  '/teacher/overview/**',
  '/payment-status*',
  '/payment/**',
  '/competitions/**/problems/**',
  '/competitions/**/problems',
  '/competitions/**/competition-leaderboard',
  '/competitions/**/submissions',
  '/batches/**/classroom/**',
  '/feedback/student/trial-class/**',
  '/apps/scratch',
  '/apps/scratch/**',
]

// Where the bounced-address bar stays quiet. Everywhere else a logged-in
// parent can reach, it shows, because an account we cannot email is broken
// until they fix it.
//
// The dashboard is the page the bar exists for, so it comes out. The trial
// funnel stays excluded because an interruption mid-booking costs the
// booking, with `/trial-class/join` carved out in the component: there the
// class is already booked, and the joining link is the thing that will not
// arrive.
export const REJECTED_EMAIL_HELLO_BAR_EXCLUSION_GLOBS = GENERAL_HELLO_BAR_EXCLUSION_GLOBS.filter(
  (glob) => !glob.startsWith('/dashboard')
)

export const UPDATE_INFO_HELLO_BAR_ENDPOINTS = [
  '/competitions',
  '/competitions/*',
  '/dashboard/student/**',
  '/trial-class/complete',
  '/trial-class/incomplete',
  '/quizzes/*',
  '/quizzes',
]

export const TEACHER_DASHBOARD_ROOT_URL = `/teacher/dashboard`

export const TEACHER_DASHBOARD_ROUTES = [
  { title: 'Dashboard', icon: 'Clipboard', url: '' },
  { title: 'Calendar', icon: 'Calendar', url: '/calendar' },
  { title: 'Review projects', icon: 'Box', url: '/projects' },
  { title: 'My students', icon: 'Users', url: '/my-students' },
  { title: 'My conversions', icon: 'TrendingUp', url: '/my-conversions' },
  { title: 'My payouts', icon: 'DollarSign', url: '/my-payouts' },
  { title: 'Browse courses', icon: 'BookOpen', url: '/browse-courses' },
  { title: 'Important links', icon: 'Link', url: '/important-links' },
  { title: "Students' feedback", icon: 'Feedback', url: '/ai-feedbacks' },
  {
    title: 'Class audits',
    icon: 'FileText',
    url: '/class-audits',
    showNewTag: true,
  },
  {
    title: 'Join Apollo team',
    icon: 'JoinApollo',
    url: '/join-apollo-team',
  },
  { title: 'Analytics', icon: 'BarChart', url: '/analytics' },
  { title: 'Refer teachers', icon: 'ReferTeachers', url: '/invite-teachers' },
  { title: 'Refer students', icon: 'ReferStudents', url: '/invite-students' },
  { title: 'Leaderboard', icon: 'Award', url: '/leaderboard' },
  { title: 'Settings', icon: 'Settings', url: '/settings' },
]

export const STUDENT_DASHBOARD_ROOT_URL = `/student/dashboard`
export const STUDENT_DASHBOARD_ROUTES = [
  { title: 'Dashboard', icon: 'Clipboard', url: '' },
  { title: 'My lessons', icon: 'BookOpen', url: '/modules' },
  { title: 'My projects', icon: 'Box', url: '/projects' },
  { title: 'My quizzes', icon: 'Quiz', url: '/quizzes' },
  { title: 'My certificates', icon: 'Certificate', url: '/certificates' },
  { title: 'My progress reports', icon: 'FileText', url: '/progress-reports' },
  { title: 'My payments', icon: 'DollarSign', url: '/my-payments' },
  { title: 'Leaderboard', icon: 'Award', url: '/leaderboard' },
  { title: 'Invite friends', icon: 'UserCheck', url: '/invite-friends' },
  { title: 'Competitions', icon: 'Trophy', url: '/competitions' },
  // { title: 'Profile', icon: 'User', url: '/profile' },
]

export const TRY_FREE_MATH_LESSON = {
  title: 'Try a free Math lesson',
  url: 'https://www.codingal.com/trial-class/booking/?course=math-trial-class',
  icon: 'ExternalLink',
}

export const TRY_FREE_CODING_LESSON = {
  title: 'Try a free AI & Coding lesson',
  url: 'https://www.codingal.com/trial-class/booking/?course=coding',
  icon: 'ExternalLink',
}

export const TRY_FREE_ELA_LESSON = {
  title: 'Try a free ELA lesson',
  url:
    'https://www.codingal.com/trial-class/booking/?course=public-speaking-trial-class',
  icon: 'ExternalLink',
}

export const EVENT_TYPES = {
  AVAILABLE_SLOT: 'Available slot',
  BOOKED_SLOT: 'Booked slot',
} as const

export const MIN_CANCELLATION_WINDOW_IN_HOURS = 0
export const CLASSROOM_GLOB = '/batches/**'
export const REGISTER_REF = 'register'
export const LOGIN_REF = 'login'
export const COMPETITIONS_REF = 'competitions'
export const BOOK_TRIAL_CLASS_REF = 'book-trial-class'
// Keeping it here as we may need it later
// export const LOGROCKET_UNINITIALIZED_PAGES = ['/terms', '/privacy-policy']

export const VIDEO_PROFILES: Record<string, any> = {
  '180x15': '180p_1',
  '360x15': '360p_1',
  '480x15': '480p_1',
  '480x30': '480p_2',
  '720x15': '720p_1',
  '720x30': '720p_2',
  '1080x15': '1080p_1',
  '1080x30': '1080p_2',
}

export const FRESHCHAT_EXCLUSION_GLOB = [
  '/batches/**',
  '/book-trial-class*',
  '/competitions/**/problems/**',
  '/feedback/**',
  '/quizzes/**/arena/**',
  '/lp/**',
  '/benefits-of-coding*',
  '/student/dashboard/**',
  '/competitions/**/register/complete/**',
]

export const LEADSQUARED_EXCLUSION_GLOBS = ['/**/dashboard/**']
export const LOCALE_REDIRECTION_EXCLUSION_GLOBS = [
  '/book-trial-class*',
  '/lp/**',
  '/benefits-of-coding*',
  '/',
]

export const INSTANT_CLASS_MODAL_GLOB = ['/feedback/**', '/batches/**']

export const SUPPORT_PHONE_NUMBER = {
  label: '+91 6361 158952',
  value: '+916361158952',
}

export const WHATSAPP_SUPPORT_NUMBER = {
  value: '+15103619534',
  label: '+1 510-361-9534',
}

export const NO_SLOTS_AVAILABLE_MESSAGE =
  "Hi Codingal Team, I'd like to book a trial coding class but there are no available slots showing. Please help me find a suitable time for a free trial class."

export const SUPPORT_EMAIL = {
  label: 'support@codingal.com',
  value: 'support@codingal.com',
}

export const AVATAR_CROP_MODAL_ID = 'avatar-crop-modal'
export const VIDEO_MODAL_ID = 'watch-video-modal'
export const MOD_LOGIN_MODAL_ID = 'mod-login-modal'
export const PASSWORD_RESET_MODAL_ID = 'password-reset-modal'
export const SWAL_CLASSES = 'swal-overlay swal-overlay--show-modal'

export const CLASS_COMPLETED_SOURCE_QUERY = {
  DASHBOARD: 'dashboard',
  COMPLETED_CLASSES: 'completed-classes',
}

export const MIN_INSTANT_TEACHER_AVAILABILITY_THRESHOLD = 3

export const SIGNUP_SOURCE_LOCAL_STORAGE_KEY = 'codingalSignupSource'

export const SYSTEM_CHECK_RESULT_LOCAL_STORAGE_KEY = 'codingalSystemCheckResult'

export const JOIN_TRIAL_CLASS_STATES = {
  DEVICE_NOT_SUPPORTED: 'device-not-supported',
  SYSTEM_CHECK: 'system-check',
  JOIN_CLASS: 'join-class',
  LOADING: 'loading',
}

// Subjects for which tablet devices are allowed to join/attend the trial class.
// Tablets are permitted for Math and ELA because these subjects don't require
// a full desktop environment unlike coding classes.
// Values match the backend enum exactly (curriculum.enums.Subject: 'Coding' | 'Math' | 'ELA').
export const TABLET_ALLOWED_SUBJECTS = ['Math', 'ELA']

export const isTabletAllowedSubject = (subject: string): boolean =>
  TABLET_ALLOWED_SUBJECTS.includes(subject)

export const REQUIRED_THIRD_PARTY_ORIGINS = ['https://support.codingal.com']
export const PREFETCH_URLS = [
  'https://fastly.codingal.com',
  'https://support.codingal.com',
  'https://www.googletagmanager.com	',
  'https://connect.facebook.net	',
  'https://web-in21.mxradon.com',
  'https://js.hscollectedforms.net',
  'https://js.hs-banner.com',
  'https://www.google-analytics.com	',
]

export const TRIAL_CLASS_BANNER_REDIRECT_LINK = {
  LOGGED_OUT: '/register',
  LOGGED_IN: '/trial-class/booking',
}

export const CODINGAL_COMMUNITY_STRENGTH = Number(1000000).toLocaleString()

export const DEFAULT_USER_DETAILS = {
  name: 'Student',
  emailDomain: '@codingal-student.com',
}

export const EXOTEL_CALLER_ID = '079-491-08561'
export const TWILLIO_CALLER_ID = '(218) 520-8003'

export const WATI_ACCOUNT_TYPE = {
  default: 'Default',
  paid: 'PAID',
}

export const ZOKO_TEMPLATE_TYPE = {
  TEMPLATE: 'template',
  RICH_TEMPLATE: 'richTemplate',
  BUTTON_TEMPLATE: 'buttonTemplate',
}

export const DEMO_TEACHER_EMAIL = 'aadishmahadik23@gmail.com'

export const TERMS_AND_POLICY_PATHS = {
  'TERMS OF SERVICE': '/terms/',
  'PRIVACY POLICY': '/privacy-policy/',
  'REFUND POLICY': '/refund-policy/',
  'PAYMENT POLICY': '/payment-policy/',
  'PRICING POLICY': '/pricing-policy/',
}

// Default values for the responsive carousel (react-multi-carousel)
export const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1288 },
    items: 4,
    slidesToSlide: 4, // optional, default to 1.
  },
  desktop: {
    breakpoint: { max: 1287, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1023, min: 768 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 200 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}

// Default values for the responsive carousel (react-multi-carousel)
export const coursePageResponsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1288 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  desktop: {
    breakpoint: { max: 1287, min: 1024 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1023, min: 768 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 200 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}

// Just update this constant here to initiate the Codingal Rewind Feature
export const CODINGAL_REWIND_YEAR = 2025

export const CODINGAL_REWIND_EXPIRY_DATE = new Date(
  CODINGAL_REWIND_YEAR + 1,
  0,
  31
)

export const COMPANY_ADDRESS = {
  INR: {
    Name: 'Codingal Technologies Private Limited',
    GSTIN: '29AAJCC2185Q1ZW',
    Address: '#147, 5th Main, HSR Layout, Bangalore, 560102, Karnataka, India',
  },
  OTHER: {
    Name: 'Codingal Inc.',
    Address: '1111B S Governors Ave #6017, Dover, DE 19904',
  },
}

// Keep in sync with the SalesTeams enum in api/apps/billing/enums.py
export const SALES_TEAM = {
  RENEWAL: 'Renewal Team',
  ELITES: 'Elites Team',
  FALCONS: 'Falcons Team',
  DREAMERS: 'Dreamers Team',
  COIMBATORE: 'Coimbatore HL Team',
  PL: 'PL Team',
  CODING_PROJECT: 'Coding Project Team',
  RANGERS: 'Rangers Team',
  HAWKEYES: 'Hawkeyes Team',
  FINANCE: 'Finance Team',
  NORTH_AMERICA: 'North America Team',
  CUSTOMER_RELATION: 'Customer Relations Team',
  APOLLO: 'Apollo Team',
  GLADIATOR: 'Gladiator Team',
  GROWTH: 'Growth Team',
  APOLLO_GLADIATORS: 'Apollo Gladiators Team',
  APOLLO_LEGENDS: 'Apollo Legends Team',
  SPARTANS: 'Spartans Team',
  TITANS: 'Titans Team',
} as const

export const RATINGS = {
  GOOGLE_RATING: {
    rating: 4.6,
  },
  TRUSTPILOT_RATING: {
    rating: 4.6,
    ratingCount: 225,
  },
  GLASSDOOR_RATING: {
    rating: 4.3,
  },
}

export const STATS = {
  COUNTRIES: '135',
  STUDENTS: '1 Million',
  TEACHERS: '1,000',
}

export const overAllRating = 4.6

export const AFRICAN_COUNTRIES = new Set([
  'AO',
  'BF',
  'BI',
  'BJ',
  'BW',
  'CD',
  'CF',
  'CG',
  'CI',
  'CM',
  'CV',
  'DJ',
  'DZ',
  'EG',
  'ER',
  'ET',
  'GA',
  'GH',
  'GM',
  'GN',
  'GQ',
  'GW',
  'KE',
  'KM',
  'LR',
  'LS',
  'LY',
  'MA',
  'MG',
  'ML',
  'MR',
  'MU',
  'MW',
  'MZ',
  'NA',
  'NE',
  'NG',
  'RW',
  'SC',
  'SD',
  'SL',
  'SN',
  'SO',
  'ST',
  'SZ',
  'TD',
  'TG',
  'TN',
  'TZ',
  'UG',
  'ZA',
  'ZM',
  'ZW',
])

export const IS_COUNTRIES = new Set([
  'AF',
  'BD',
  'BT',
  'IN',
  'LK',
  'MV',
  'NP',
  'PK',
])
